var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageTemplateBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3V9H21V3H3ZM19 5H5V7H19V5Z",
    fill: "#5555FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11V21H11V11H3ZM9 13H5V19H9V13Z",
    fill: "#5555FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11H13V13H21V11Z",
    fill: "#5555FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H21V17H13V15Z",
    fill: "#5555FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19H13V21H21V19Z",
    fill: "#5555FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTemplateBlue);
export default __webpack_public_path__ + "static/media/MessageTemplateBlue.8717bdf651b656e90fedfe1c8b0780c6.svg";
export { ForwardRef as ReactComponent };